import { BrokerLaneDetails } from '../views/index';
import { TruckLane } from '../dtos/index';
import { IS_NOT_EMPTY } from '../../utils/stringUtils/string-utils';
import { IS_NOT_NULL_OR_UNDEFINED } from '../../utils/commonUtils/index';

export const BROKER_LANE_DETAILS_TABLE = (
	lanesList: Array<TruckLane> = []
): Array<BrokerLaneDetails> => {
	let results: Array<BrokerLaneDetails> = [];
	if (lanesList.length > 0) {
		lanesList.map((lane) => {
			let row = {} as BrokerLaneDetails;
			row.origin =
				(IS_NOT_EMPTY(lane.originCity) ? lane.originCity + ', ' : '') +
				(IS_NOT_EMPTY(lane.originState) ? lane.originState : '');
			if (IS_NOT_EMPTY(lane.destCity)) {
				row.destination = lane.destCity;
				if (IS_NOT_EMPTY(lane.destState)) {
					row.destination += ', ' + lane.destState;
				}
			} else if (IS_NOT_EMPTY(lane.destState)) {
				row.destination = lane.destState;
			} else if (IS_NOT_EMPTY(lane.destinationStates)) {
				row.destination = lane.destinationStates;
			} else {
				row.destination = '';
			}
			row.equipment = lane.trailerType;
			row.frequency = getFrequency(lane);
			row.lastMatch = null;
			row.lastBooked = null;
			row.lastRate = IS_NOT_NULL_OR_UNDEFINED(lane.rate) ? lane.rate / 100 : null;
			row.carrierId = lane.carrierId;
			row.laneId = lane.id;
			row.rateUpdatedAt = lane.rateUpdatedAt;
			row.ltl = lane.ltl;
			results.push(row);
		});
	}
	return results;
};

export const getFrequency = (lane: TruckLane): string => {
	let result = '';
	if (lane.runDaily != undefined && lane.runDaily != null && lane.runDaily) {
		result = 'Daily';
	} else if (
		lane.monday ||
		lane.tuesday ||
		lane.wednesday ||
		lane.thursday ||
		lane.friday ||
		lane.saturday ||
		lane.sunday
	) {
		let daysOfWeek = [];
		if (lane.monday) {
			daysOfWeek.push('M');
		}
		if (lane.tuesday) {
			daysOfWeek.push('T');
		}
		if (lane.wednesday) {
			daysOfWeek.push('W');
		}
		if (lane.thursday) {
			daysOfWeek.push('TH');
		}
		if (lane.friday) {
			daysOfWeek.push('F');
		}
		if (lane.saturday) {
			daysOfWeek.push('SAT');
		}
		if (lane.sunday) {
			daysOfWeek.push('SUN');
		}
		if (daysOfWeek.length > 0) {
			result = daysOfWeek.join(', ');
		}
	} else if (lane.weeklyFrequency != undefined && lane.weeklyFrequency != null) {
		result = lane.weeklyFrequency.toString();
	}

	return result;
};
